import { createFileRoute, redirect } from "@tanstack/react-router"

// The admin area starts at the tenant list; there is no separate overview.
export const Route = createFileRoute("/_app/admin/")({
  beforeLoad: () => redirect({ to: "/admin/mandanten", replace: true, throw: true }),
})
